import * as XLSX from 'xlsx';
import { Customer } from '../types/customer';

export const exportToExcel = (customers: Customer[], searchTerm: string = '') => {
  // Prepare data for export
  const exportData = customers.map((customer, index) => ({
    'Sr. No.': index + 1,
    'Firm Name': customer.firmName || '',
    'Owner Name': customer.name || '',
    'Mobile1 Name': customer.mobileNumberRef1 || '',
    'Mobile No. 1': customer.mobileNumber1 || '',
    'Mobile2 Name': customer.mobileNumberRef2 || '',
    'Mobile No. 2': customer.mobileNumber2 || '',
    'Mobile3 Name': customer.mobileNumberRef3 || '',
    'Mobile No. 3': customer.mobileNumber3 || '',
    'Mobile4 Name': customer.mobileNumberRef4 || '',
    'Mobile No. 4': customer.mobileNumber4 || '',
    'Mobile5 Name': customer.mobileNumberRef5 || '',
    'Mobile No. 5': customer.mobileNumber5 || '',
    'Aadhar Card No.': customer.aadharCardNumber || '',
    'Address': customer.permanentAddress || '',
    'Pan Card No.': customer.panCardNumber || '',
    'GST No.': customer.gstNumber || '',
    'Udhyog Adhar No.': customer.udhyogAadharNumber || '',
    'Udhyog Adhar category': customer.udhyogAadharCategory || ''
  }));

  // Create workbook and worksheet
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(exportData);

  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(wb, ws, 'Customers');

  // Generate filename with date and search term
  const date = new Date().toISOString().split('T')[0];
  const searchSuffix = searchTerm ? `_search_${searchTerm}` : '';
  const fileName = `customers_${date}${searchSuffix}.xlsx`;

  // Save file
  XLSX.writeFile(wb, fileName);
};

export const exportEmployeeToExcel = (data: any[], searchQuery?: string) => {
  // Transform employee data for Excel
  const excelData = data.map((item, index) => {
    // compute age from dateOfBirth if present
    const age = item.dateOfBirth ? (() => {
      const b = new Date(item.dateOfBirth);
      if (isNaN(b.getTime())) return '';
      const today = new Date();
      let a = today.getFullYear() - b.getFullYear();
      const m = today.getMonth() - b.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < b.getDate())) a--;
      return a >= 0 ? a : '';
    })() : '';

    return {
      'Sr. No.': index + 1,
      'Name': `${item.firstName || ''} ${item.surname || ''}`.trim(),
      'Mobile No.': item.mobileNumber || '',
      'Current Address': item.currentAddress || '',
      'Residential Address': item.residentialAddress || '',
      'Caste': item.caste || '',
      'Date of Birth': item.dateOfBirth ? new Date(item.dateOfBirth).toLocaleDateString() : '',
      'Age': age,
      'Education': item.education || '',
      'Identification Mark': item.identificationMark || '',
      'Work Place': item.workPlace || '',
      'Joining Date': item.joiningDate ? new Date(item.joiningDate).toLocaleDateString() : '',
      'Exit Date': item.exitDate ? new Date(item.exitDate).toLocaleDateString() : '',
      "Father's Name": item.fatherName || '',
      "Father's Mobile": item.fatherMobileNumber || '',
      "Mother's Name": item.motherName || '',
      "Mother's Mobile": item.motherMobileNumber || '',
      'Pradhan Name': item.pradhanName || '',
      'Pradhan Mobile No.': item.prdhanMobile || '',
      'Police Station': item.policeStation || '',
      'Police Station Mobile No.': item.policeMobile || '',
      'Aadhar Card No.': item.aadharNumber || '',
      'Pan Card No.': item.panNumber || '',
      'Account No.': item.accountNumber || '',
      'IFSC Code': item.ifscCode || '',
      'Bank Name': item.bankName || '',
      'Branch Name': item.bankBranch || ''
    };
  });

  // Create workbook
  const wb = XLSX.utils.book_new();
  
  // Create worksheet with the data
  const ws = XLSX.utils.json_to_sheet(excelData);

  // Set custom column widths
  const colWidths = [
    { wch: 5 },  // Sr. No.
    { wch: 25 }, // Name
    { wch: 15 }, // Mobile No.
    { wch: 30 }, // Current Address
    { wch: 30 }, // Residential Address
    { wch: 12 }, // Caste
    { wch: 12 }, // Date of Birth
    { wch: 5 },  // Age
    { wch: 15 }, // Education
    { wch: 25 }, // Identification Mark
    { wch: 20 }, // Work Place
    { wch: 12 }, // Joining Date
    { wch: 12 }, // Exit Date
    { wch: 20 }, // Father's Name
    { wch: 15 }, // Father's Mobile
    { wch: 20 }, // Mother's Name
    { wch: 15 }, // Mother's Mobile
    { wch: 20 }, // Pradhan Name
    { wch: 15 }, // Pradhan Mobile
    { wch: 20 }, // Police Station
    { wch: 15 }, // Police Station Mobile
    { wch: 18 }, // Aadhar Card No.
    { wch: 15 }, // Pan Card No.
    { wch: 20 }, // Account No.
    { wch: 12 }, // IFSC Code
    { wch: 20 }, // Bank Name
    { wch: 20 }  // Branch Name
  ];

  ws['!cols'] = colWidths;

  // Add the worksheet to workbook
  XLSX.utils.book_append_sheet(wb, ws, 'Employees');

  // Generate filename with search query and current date
  const date = new Date().toISOString().split('T')[0];
  const searchSuffix = searchQuery ? `_${searchQuery}` : '';
  const fileName = `employee_list${searchSuffix}_${date}.xlsx`;

  // Save the file
  XLSX.writeFile(wb, fileName);
};